import { api } from "@/lib/axios";
import { useQuery } from "@tanstack/react-query";
import { MonthlyTransportParams, MonthlyTransportResponse } from "@/interface/settlement/monthlyTransport/index";

export const useMonthlyTransport = (params: MonthlyTransportParams) => {
    const { startYear, startMonth, endYear, endMonth, searchType, search, exactMatch, company, page = 0, size = 20 } = params;

    return useQuery<MonthlyTransportResponse>({
        queryKey: ["monthlyTransport", params],
        queryFn: async () => {
            const response = await api.get("/monthly-transport", {
                params: {
                    startYear,
                    startMonth,
                    endYear,
                    endMonth,
                    searchType,
                    search,
                    exactMatch,
                    company,
                    page,
                    size,
                },
            });
            return response.data;
        },
        gcTime: 0,
        refetchOnMount: true,
    });
};
